module.exports = __webpack_public_path__ + "img/3D-3BHK.66b913bf.png";